import { ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { authHttpInterceptorFn, provideAuth0 } from '@auth0/auth0-angular';
import { provideMEL } from '@maid/masta';

import { routes } from './app.routes';
import { provideTranslation } from './core/i18n/translation.config';
import { environment } from '../environments/environment';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideAnimations(),
    provideHttpClient(withInterceptors([authHttpInterceptorFn])),
    provideRouter(routes, withComponentInputBinding()),

    // --- MEL / @maid/masta (Markant design system) ---
    // Configures PrimeNG with the MastaPreset + `.mel-dark-mode` selector.
    provideMEL(),

    // --- PrimeNG fallback (enable ONLY if provideMEL() above is removed) ---
    // Requires: import { providePrimeNG } from 'primeng/config';
    //           import Aura from '@primeuix/themes/aura';
    // providePrimeNG({
    //   theme: {
    //     preset: Aura,
    //     options: {
    //       darkModeSelector: DARK_MODE_SELECTOR,
    //     },
    //   },
    // }),

    provideAuth0({
      domain: environment.auth0.domain ?? '',
      clientId: environment.auth0.clientId ?? '',
      authorizationParams: {
        redirect_uri: typeof window !== 'undefined' ? window.location.origin : undefined,
      },
      httpInterceptor: {
        allowedList: environment.allowedApiUrls,
      },
    }),

    provideTranslation(),
  ],
};
